import { Text } from "@mantine/core";
import type { ReactNode } from "react";

interface IHelpCenterTextProps {
  children: ReactNode | string;
  className?: string;
}

const HelpCenterText: React.FC<IHelpCenterTextProps> = ({
  children,
  className,
}) => {
  return (
    <Text className={`my-7 font-inter text-lg ${className}`}>{children}</Text>
  );
};

export default HelpCenterText;
